import React from 'react';
import LogoLinkAside from 'site_version/common/aside/LogoLinkAside';
import LogoClashSvg from 'images/svg_icons/image-clash-casino.svg';
import LogoTipsGGSvg from 'images/tipsgg/logo.png';
import BookmakerRating from 'site_version/common/aside/BookmakerRating';

const banners = (): React.ReactNode => <>
    <LogoLinkAside
        className="tips"
        link="https://tips.gg/"
        logo={LogoTipsGGSvg}
        logoAlt="Logo tipsgg"
    />
    <LogoLinkAside
        className="clash"
        link="https://clashofslots.com/casinos/egb-casino/"
        logo={LogoClashSvg}
        logoAlt="Logo clash"
    />
    <BookmakerRating/>
</>;

export default banners;
